(function ($) {

  if ($('.media-iframe').length) {
    $('.media-iframe').each(function () {
      let iframe = $(this);
      let videoSRC = iframe.attr('data-src');
      let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      let match = videoSRC.match(regExp);
      if (match) {
        iframe.attr('src', 'https://www.youtube.com/embed/' + match[2] + '?autoplay=0');
      } else {
        iframe.attr('src', videoSRC);
      }
    });
  }

})(jQuery);
